import { useQuery } from 'data-fetching-client';
import { GET_PUBLIC_FEATURE_FLAGS } from '../queries/featureFlagQueries';
import { applyFeatureFlagOverrides } from 'pricing-pages-ui-components/utils/debugOverrides';
import { getCountryCodeFromLocale } from '../utils/countryCodeUtils';
import { getBrowserLocale } from '../utils/getPreferredLanguage';
import { getUtk } from '../utils/getUtk';
import { DEFAULT_CHIRP_TIMEOUT } from '../constants/chirpDefaults';
export function usePublicFeatureFlags({
  skip
} = {}) {
  var _data$featureFlags$ac, _data$featureFlags;
  const browserLocale = getBrowserLocale();
  const preferredCountryCode = getCountryCodeFromLocale();
  const utk = getUtk();
  const {
    data,
    loading,
    error
  } = useQuery(GET_PUBLIC_FEATURE_FLAGS, {
    variables: {
      utk,
      browserLocale,
      preferredCountryCode
    },
    skip,
    context: {
      timeout: DEFAULT_CHIRP_TIMEOUT
    }
  });
  const emptyFlags = [];
  const rawFlags = (_data$featureFlags$ac = data === null || data === void 0 || (_data$featureFlags = data.featureFlags) === null || _data$featureFlags === void 0 ? void 0 : _data$featureFlags.activeFeatureFlags) !== null && _data$featureFlags$ac !== void 0 ? _data$featureFlags$ac : emptyFlags;
  const featureFlags = applyFeatureFlagOverrides(rawFlags);
  return {
    featureFlags,
    loading,
    error
  };
}